module.exports = __webpack_public_path__ + "img/sinaLogo.7187a6da.jpg";